/* import __COLOCATED_TEMPLATE__ from './empty-state-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
}

const EmptyStateCellComponent = templateOnlyComponent<Signature>();

export default EmptyStateCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::EmptyStateCell': typeof EmptyStateCellComponent;
    'knowledge-hub/filterable-list/table/cells/empty-state-cell': typeof EmptyStateCellComponent;
  }
}
